<template>
  <div class="btn">
    <p class="name">{{ props.name }}</p>
    <div class="btnBox">
      <!--散户件，平台件，回退件-->
      <van-button
        v-for="(item, i) in props.list"
        :key="i"
        class="btnStyle"
        type="default"
        :color="indexValue === item.code ? '#E60012' : ''"
        plain
        round
        @click="() => click(item.code)"
        >{{ lang(item.text) }}</van-button
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import lang from '@/langs'

const props = defineProps({
  list: {
    // 下拉区域始终为全屏的高度
    type: Array,
    default: () => []
  },
  name: {
    type: String,
    default: ''
  },
  index: {
    type: Number,
    default: 0
  }
})

const emits = defineEmits(['click'])
const indexValue = ref(0)
const click = (val: number) => {
  emits('click', val)
}
watch(
  () => props.index,
  (value) => {
    indexValue.value = value
  }
)
</script>

<style scoped lang="less">
.btn {
  .name {
    margin-bottom: 12px;
    font-size: 14px;
  }
  .btnBox {
    margin-bottom: 16px;
    .btnStyle {
      margin: 4px 4px;
      min-width: 60px;
      height: 30px;
      font-size: 12px;
    }
  }
}
</style>
